(() => {
  const mainSubmit = document.querySelector('#cm-product-form [data-cm-submit]');
  const stickyBar = document.querySelector('[data-cm-sticky-cart]');
  if (mainSubmit && stickyBar) {
    const syncSticky = () => {
      stickyBar.classList.toggle('is-visible', mainSubmit.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    document.addEventListener('scroll', syncSticky, { passive: true, capture: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();
  }

  const gallery = document.querySelector('[data-cm-gallery]');
  if (gallery) {
    const slides = [...gallery.querySelectorAll('[data-cm-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-cm-thumb]')];
    const thumbRail = gallery.querySelector('[data-cm-thumb-rail]');
    const reviewDisclosure = gallery.querySelector('[data-cm-review-disclosure]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;

    const show = (next) => {
      current = (next + slides.length) % slides.length;
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === current));
      if (reviewDisclosure) reviewDisclosure.hidden = !slides[current].classList.contains('cm-gallery__reviews-slide');
      thumbs.forEach((thumb, position) => {
        thumb.classList.toggle('is-active', position === current);
        thumb.setAttribute('aria-pressed', String(position === current));
      });
      if (thumbRail && thumbs[current]) {
        const railBounds = thumbRail.getBoundingClientRect();
        const thumbBounds = thumbs[current].getBoundingClientRect();
        const left = thumbBounds.left - railBounds.left - (railBounds.width - thumbBounds.width) / 2;
        thumbRail.scrollBy({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    };

    gallery.querySelector('[data-cm-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-cm-next]')?.addEventListener('click', () => show(current + 1));
    gallery.querySelector('[data-cm-thumb-prev]')?.addEventListener('click', () => show(current - 1));
    gallery.querySelector('[data-cm-thumb-next]')?.addEventListener('click', () => show(current + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.cmThumb))));

    const stage = gallery.querySelector('.cm-gallery__stage');
    if (stage) {
      let touchStart = null;
      stage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) {
          touchStart = null;
          return;
        }
        touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (!touchStart || !window.matchMedia('(max-width: 767px)').matches || !event.changedTouches.length) return;
        const deltaX = event.changedTouches[0].clientX - touchStart.x;
        const deltaY = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) show(current + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
      stage.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
    }
  }

  const subtitle = document.querySelector('[data-cm-subtitle-typing]');
  if (subtitle) {
    const phrases = ['tu circulación', 'tu vida', 'tu energía', 'tu rendimiento físico'];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let length = phrases[0].length;
    let deleting = true;
    let visible = !('IntersectionObserver' in window);
    let timer = 0;

    const step = () => {
      timer = 0;
      if (!visible || document.hidden || reducedMotion.matches) return;
      if (deleting) {
        length -= 1;
        subtitle.textContent = phrases[current].slice(0, length);
        if (length === 0) {
          current = (current + 1) % phrases.length;
          deleting = false;
          timer = window.setTimeout(step, 220);
        } else {
          timer = window.setTimeout(step, 45);
        }
      } else {
        length += 1;
        subtitle.textContent = phrases[current].slice(0, length);
        if (length === phrases[current].length) {
          deleting = true;
          timer = window.setTimeout(step, 2000);
        } else {
          timer = window.setTimeout(step, 75);
        }
      }
    };
    const sync = () => {
      window.clearTimeout(timer);
      timer = 0;
      current = 0;
      length = phrases[0].length;
      deleting = true;
      subtitle.textContent = phrases[0];
      subtitle.classList.toggle('is-active', visible && !document.hidden && !reducedMotion.matches);
      if (visible && !document.hidden && !reducedMotion.matches) timer = window.setTimeout(step, 2000);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        sync();
      }, { threshold: .1 });
      observer.observe(subtitle);
    }
    document.addEventListener('visibilitychange', sync);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', sync);
    else reducedMotion.addListener(sync);
    sync();
  }

  document.querySelectorAll('.cm-detail-accordion').forEach((accordion) => {
    const items = [...accordion.querySelectorAll('details')];
    items.forEach((item) => item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((other) => {
        if (other !== item) other.open = false;
      });
    }));
  });

  const benefits = document.querySelector('[data-cm-benefits]');
  if (benefits && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const playBenefits = () => {
      benefits.querySelectorAll('[data-cm-benefit-value]').forEach((item, index) => {
        const target = Number(item.dataset.cmBenefitValue);
        const count = item.querySelector('[data-cm-benefit-count]');
        const fill = item.querySelector('.cm-benefit-grid__fill');
        if (!count || !fill?.animate || !Number.isFinite(target)) return;
        const delay = index * 120;
        const duration = 850;
        fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration, delay, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'both' });
        const start = performance.now() + delay;
        const tick = (now) => {
          const progress = Math.min(1, Math.max(0, (now - start) / duration));
          count.textContent = `${Math.round(target * (1 - Math.pow(1 - progress, 3)))}%`;
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          playBenefits();
        }
      }, { threshold: .25 });
      observer.observe(benefits);
    } else {
      playBenefits();
    }
  }

  const voices = document.querySelector('[data-cm-voices]');
  if (voices) {
    const viewport = voices.querySelector('[data-cm-voices-viewport]');
    const cards = [...viewport.querySelectorAll('.cm-voices__card')];
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const move = (direction) => {
      if (!cards.length) return;
      const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : viewport.clientWidth;
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const left = viewport.scrollLeft;
      const target = direction > 0 && left >= max - 2 ? 0 : direction < 0 && left <= 2 ? max : Math.max(0, Math.min(max, left + direction * step));
      viewport.scrollTo({ left: target, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };
    voices.querySelector('[data-cm-voices-prev]')?.addEventListener('click', () => move(-1));
    voices.querySelector('[data-cm-voices-next]')?.addEventListener('click', () => move(1));
  }

  const delivery = document.querySelector('[data-cm-delivery-slider]');
  if (delivery) {
    const viewport = delivery.querySelector('.cm-delivery__viewport');
    const track = delivery.querySelector('.cm-delivery__track');
    const groups = [...delivery.querySelectorAll('.cm-delivery__group')];
    if (viewport && track && groups.length === 2) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let cycleWidth = 0;
      let offset = 0;
      let frame = 0;
      let lastFrame = 0;
      let inView = !('IntersectionObserver' in window);
      let pointer = null;
      let resumeTimer = 0;

      const wrap = (value) => ((value % cycleWidth) + cycleWidth) % cycleWidth - cycleWidth;
      const render = () => { track.style.transform = `translate3d(${offset}px, 0, 0)`; };
      const stop = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        lastFrame = 0;
      };
      const measure = () => {
        if (reducedMotion.matches) return;
        const width = groups[1].offsetLeft - groups[0].offsetLeft;
        if (width <= 0) return;
        offset = cycleWidth ? offset * width / cycleWidth : -width;
        cycleWidth = width;
        offset = wrap(offset);
        render();
      };
      const tick = (now) => {
        frame = 0;
        if (!inView || document.hidden || reducedMotion.matches || pointer || resumeTimer) {
          lastFrame = 0;
          return;
        }
        if (lastFrame && cycleWidth) {
          offset = wrap(offset + Math.min(now - lastFrame, 64) * cycleWidth / 28000);
          render();
        }
        lastFrame = now;
        frame = requestAnimationFrame(tick);
      };
      const sync = () => {
        if (inView && !document.hidden && !reducedMotion.matches && !pointer && !resumeTimer) {
          if (!frame) frame = requestAnimationFrame(tick);
        } else {
          stop();
        }
      };
      const delayResume = () => {
        clearTimeout(resumeTimer);
        resumeTimer = window.setTimeout(() => {
          resumeTimer = 0;
          sync();
        }, 1200);
      };

      measure();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          sync();
        }, { threshold: 0.05 });
        observer.observe(delivery);
      }
      document.addEventListener('visibilitychange', sync);
      window.addEventListener('resize', measure);
      const syncMotionPreference = () => {
        stop();
        if (reducedMotion.matches) track.style.transform = '';
        else measure();
        sync();
      };
      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', syncMotionPreference);
      else reducedMotion.addListener(syncMotionPreference);
      sync();

      viewport.addEventListener('pointerdown', (event) => {
        if (pointer || (event.pointerType === 'mouse' && event.button !== 0)) return;
        if (event.pointerType === 'touch' && reducedMotion.matches) return;
        clearTimeout(resumeTimer);
        resumeTimer = 0;
        stop();
        if (!reducedMotion.matches && !cycleWidth) measure();
        pointer = { id: event.pointerId, x: event.clientX, offset, scroll: viewport.scrollLeft };
        viewport.setPointerCapture(event.pointerId);
        delivery.classList.add('is-dragging');
      });
      viewport.addEventListener('pointermove', (event) => {
        if (!pointer || event.pointerId !== pointer.id) return;
        const distance = event.clientX - pointer.x;
        if (reducedMotion.matches) viewport.scrollLeft = pointer.scroll - distance;
        else if (cycleWidth) {
          offset = wrap(pointer.offset + distance);
          render();
        }
        event.preventDefault();
      });
      const finishDrag = (event) => {
        if (!pointer || event.pointerId !== pointer.id) return;
        pointer = null;
        delivery.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        if (!reducedMotion.matches) delayResume();
      };
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('lostpointercapture', finishDrag);

      viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const gap = parseFloat(getComputedStyle(groups[0]).gap) || 0;
        const distance = (groups[0].firstElementChild?.offsetWidth || viewport.clientWidth) + gap;
        const direction = event.key === 'ArrowRight' ? -1 : 1;
        if (reducedMotion.matches) viewport.scrollLeft -= direction * distance;
        else if (cycleWidth) {
          stop();
          offset = wrap(offset + direction * distance);
          render();
          delayResume();
        }
      });
    }
  }

  const menuButton = document.querySelector('.cm-menu-toggle');
  const menu = document.querySelector('#cm-nav');
  if (menuButton && menu) {
    const close = () => {
      menu.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Abrir menú');
    };
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  document.querySelectorAll('[data-cm-dialog-open]').forEach((button) => {
    const dialog = document.getElementById(button.dataset.cmDialogOpen);
    if (!dialog) return;
    button.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
    });
  });
  document.querySelectorAll('.cm-info-dialog').forEach((dialog) => {
    dialog.querySelector('[data-cm-dialog-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });

  const form = document.querySelector('#cm-product-form');
  if (form) {
    const radios = [...form.querySelectorAll('[data-cm-variant]')];
    const idInput = form.querySelector('[data-cm-variant-id]');
    const cartError = form.querySelector('[data-cm-cart-error]');
    let isSubmitting = false;
    const select = (radio) => {
      if (!radio) return;
      radios.forEach((item) => item.closest('.cm-pack')?.classList.toggle('is-selected', item === radio));
      if (idInput) idInput.value = radio.value;
      const purchasable = radio.dataset.purchasable === 'true';
      if (mainSubmit) {
        mainSubmit.disabled = isSubmitting || !purchasable;
        const label = mainSubmit.querySelector('[data-cm-submit-label]');
        if (label) label.textContent = isSubmitting ? 'PREPARANDO TU PEDIDO…' : purchasable ? 'AÑADIR AL CARRITO' : 'COMPRA NO DISPONIBLE TODAVÍA';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      history.replaceState({}, '', url);
    };
    radios.forEach((radio) => radio.addEventListener('change', () => select(radio)));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (isSubmitting) return;
      const selected = radios.find((radio) => radio.checked);
      if (!selected || selected.dataset.purchasable !== 'true') return;
      const variantId = Number(selected.value);
      if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
      isSubmitting = true;
      if (cartError) cartError.hidden = true;
      select(selected);
      const root = window.Shopify?.routes?.root || '/';
      try {
        const cleared = await fetch(root + 'cart/clear.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        if (!cleared.ok) throw new Error('cart_clear_failed');
        const emptyCart = await cleared.json();
        if (emptyCart.item_count !== 0) throw new Error('cart_not_empty');
        if (emptyCart.note || Object.keys(emptyCart.attributes || {}).length) {
          const attributes = Object.fromEntries(Object.keys(emptyCart.attributes || {}).map((key) => [key, '']));
          const reset = await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ note: '', attributes }),
          });
          if (!reset.ok) throw new Error('cart_reset_failed');
        }
        const added = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        if (!added.ok) throw new Error('cart_add_failed');
        window.location.assign('/checkout');
      } catch {
        isSubmitting = false;
        if (cartError) {
          cartError.textContent = 'No pudimos preparar tu pedido. Intentá de nuevo.';
          cartError.hidden = false;
        }
        select(selected);
      }
    });
  }
})();
